module Meevo.Plugins.StandingBlocks {
  "use strict";

  /**
  * Main Section of Client 
  */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.BlockSchedule> {
        // TODO: Move choices into constants file
        numberOfOccurrencesChoice = "1";
        endByChoice = "2";
        endingChoice = this.numberOfOccurrencesChoice;
        dayOfWeekChoice = "1";
        dayOfMonthChoice = "2";
        monthlyChoice = this.dayOfWeekChoice;
        defaultEndDate: any = moment().startOf("day").toDate();
        defaultTotalOccurrences = 1;
        defaultOccurrenceInterval = 14;
        defaultDayOfMonth = 1;
        startTimeTemp: any;
        endTimeTemp: any;
        employee: any;
        public increments = [];
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            public durationIncrements,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?:string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey);
            this.durationIncrements.getIncrements(480, false)
                .then((increments) => {
                    this.increments = increments;
                    if (this.model && this.model.durationInMinutes == 0) {
                        this.model.durationInMinutes = increments[0];
                    }
                });
        }

        createSectionModelInstance(postAdd:(data:any)=>any): void {
            let instance: Model.BlockSchedule = {
                id: Guid.empty.toString(),
                objectState: Meevo.Model.ObjectStateEnum.Active,
                daysOfWeek: [],
                frequency: 1,
                totalOccurrences: this.defaultTotalOccurrences,
                frequencyUnit: Meevo.Model.DateTimeUnitEnum.Day,
                occurrenceInInterval: this.defaultOccurrenceInterval,
                startDate: moment().startOf("day").toDate(),
                durationInMinutes: 0,
                resources: [],
                isAllEmployees: false, 
                isAllResources: false,
                displayReasonOnBook: false
            };

            this.model = instance;
            this.endingChoice = this.numberOfOccurrencesChoice;
            this.startTimeTemp = {
                value: moment("09:00", "HH:mm").toDate()
            };
            this.endTimeTemp = {
                value: moment("09:30", "HH:mm").toDate()
            };
            this.model.employeeIds = [];
            this.model.resourceIds = [];
        }

        sectionModelRetrieved(): void {
            if (this.model) {
                this.model.isAllResources = this.model.isAllEmployees = false;
                this.startTimeTemp = { value: moment(this.model.startTime, "HH:mm").toDate() };
                this.endTimeTemp = { value: moment(this.model.startTime, "HH:mm").add(this.model.durationInMinutes, 'minutes').toDate() };

                this.endingChoice = this.model.endDate ? this.endByChoice : this.numberOfOccurrencesChoice;
                this.monthlyChoice = this.model.dayOfMonth ? this.dayOfMonthChoice : this.dayOfWeekChoice;
            }   
        }

        createSectionModelCopy(): Model.BlockSchedule {
            let item = <Model.BlockSchedule>(angular.extend({}, this.model));
            item.id = null;
            item.isAllResources = item.isAllEmployees = false;
            item.employeeIds = [];
            item.resourceIds = [];
            return item;
        }

        preSave(): void {
            // Need starttimetemp prop b/c if we set time back to timespan, it will cause binding
            // to control to fail
            this.model.startTime = moment(this.startTimeTemp.value).format("HH:mm:ss.SSSSSSS");
            this.model.blockTypeId = this.model.blockType.id;
        }

        private _activeState: boolean;

        get activeState(): boolean {
            if (this.model !== undefined) {
                if (this.model.objectState === Model.ObjectStateEnum.Active) {
                    return true;
                }
            }

            return false;
        }

        set activeState(value: boolean) {
            if (this.model !== undefined) {
                if (value) {
                    this.model.objectState = Model.ObjectStateEnum.Active;
                } else {
                    if (this.model.objectState !== Model.ObjectStateEnum.Deleted) {
                        this.model.objectState = Model.ObjectStateEnum.Inactive;
                    }
                }
            }
        }
        
        blockTypeChanged(): void {
            if (this.model.blockType) {
                if (!this.model.displayReasonOnBook) {
                    this.model.reason = this.model.blockType.displayName;
                }
                this.dataService.getItem("blockType", new Guid(this.model.blockType.id))
                    .then((blockType: any) => {
                        if (blockType.defaultMinutes) {
                            this.model.durationInMinutes = blockType.defaultMinutes;
                        }
                    });
            }
        }
        isDeleted():boolean {
            return this.model && this.model.objectState && (this.model.objectState === Model.ObjectStateEnum.Deleted);
        }

        displayReasonOnBookChanged() {
            if (this.model.displayReasonOnBook) {
                this.model.reason = (this.model.reason == this.model.blockType.displayName) ? "" : this.model.reason;
            }
            else {
                this.model.reason = this.model.blockType.displayName;
            }
        }
    }

}